export function formatCmpctNumber(number: number) {
	let commas: Intl.NumberFormatOptions = {
		notation: "standard",
		compactDisplay: "short",
		maximumFractionDigits: 0,
		style: "currency",
		currency: "USD",
	};
	const usformatter = Intl.NumberFormat("en-US", commas);
	return usformatter.format(number);
}
export function formatChartData(number: number) {
	let options: Intl.NumberFormatOptions = {
		notation: "compact",
		compactDisplay: "short",
		maximumFractionDigits: 2,
		style: "currency",
		currency: "USD",
	};
	const usformatter = Intl.NumberFormat("en-US", options);
	return usformatter.format(number);
}
export function formatAsPercentage(number: number) {
	return `${(Number(number) * 100).toFixed(2) ?? 0}%`;
}
